// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  grid-gap: 8px;
  align-items: center;
}
@media all and (hover) {
  .checkbox {
    cursor: pointer;
  }
}
.checkbox__picture {
  height: 26px;
}
@media all and (min-width: 1280px) {
  .checkbox__picture {
    height: 32px;
  }
}
.checkbox img {
  width: 26px;
  height: 26px;
}
@media all and (min-width: 1280px) {
  .checkbox img {
    width: 32px;
    height: 32px;
  }
}
.checkbox__field {
  display: none;
}
.checkbox--required {
  color: #EF3124;
}`, "",{"version":3,"sources":["webpack://./src/components/FormikCheckbox/FormikCheckbox.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AADF;AAGE;EANF;IAOI,eAAA;EAAF;AACF;AAEE;EACE,YAAA;AAAJ;AAEI;EAHF;IAII,YAAA;EACJ;AACF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAEI;EAJF;IAKI,WAAA;IACA,YAAA;EACJ;AACF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,cCjBQ;ADgBZ","sourcesContent":["@import 'src/styles/variables';\n\n.checkbox {\n  user-select: none;\n  display: flex;\n  grid-gap: 8px;\n  align-items: center;\n\n  @media all and (hover) {\n    cursor: pointer;\n  }\n\n  &__picture {\n    height: 26px;\n\n    @media all and (min-width: $desktop) {\n      height: 32px;\n    }\n  }\n\n  img {\n    width: 26px;\n    height: 26px;\n\n    @media all and (min-width: $desktop) {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  &__field {\n    display: none;\n  }\n\n  &--required {\n    color: $alfa-bank;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
